import Typography from '@mui/material/Typography';

export default function Header({label,...props}) {
    return (<Typography variant="h5" sx={{textAlign: "center", marginY: 1}} {...props}>{label}</Typography>);
}

